import { type FC } from "react";
import * as styles from "./styles.css";

type SalaryParted = {
  manPart?: string;
  remainderPart?: string;
  yenPart?: string;
  unit: string;
};

export type SalariesProps = {
  salaryContents: {
    employmentTypeName: string;
    salaryTypeName: string;
    minPrice: string;
    minUnit: string;
    maxPrice: string;
    maxUnit: string;
    minSalaryParted?: SalaryParted | null;
    maxSalaryParted?: SalaryParted | null;
    isEllipsisDisplay: boolean;
  }[];
};

// 構造化データから給与を表示（優先的に使用）
const renderSalaryFromParted = (salaryParted: SalaryParted | null | undefined) => {
  if (!salaryParted) return null;

  if (salaryParted.yenPart) {
    // 1万円未満の場合
    return (
      <>
        <span className={styles.salaryText}>{salaryParted.yenPart}</span>
        <span className={styles.salaryText}>{salaryParted.unit}</span>
      </>
    );
  }

  if (salaryParted.manPart) {
    // 1万円以上の場合
    // unit は "万円" または "円" が返される
    // remainderPart がある場合は unit は "円"、ない場合は unit は "万円"
    return (
      <>
        <span className={styles.salaryText}>{salaryParted.manPart}</span>
        <span className={styles.salaryText}>万</span>
        {salaryParted.remainderPart ? (
          <>
            <span className={styles.salaryText}>{salaryParted.remainderPart}</span>
            <span className={styles.salaryText}>{salaryParted.unit}</span>
          </>
        ) : (
          <span className={styles.salaryText}>円</span>
        )}
      </>
    );
  }

  return null;
};

export const Salaries: FC<SalariesProps> = ({ salaryContents }) => (
  <div className={styles.salary}>
    {salaryContents.map(
      ({
        employmentTypeName,
        salaryTypeName,
        minPrice,
        minUnit,
        maxPrice,
        maxUnit,
        minSalaryParted,
        maxSalaryParted,
        isEllipsisDisplay,
      }) => {
        // 構造化データを使用（バックエンドから常に返される）
        const minSalaryDisplay = renderSalaryFromParted(minSalaryParted);
        const maxSalaryDisplay = renderSalaryFromParted(maxSalaryParted);
        const hasSalary = minSalaryDisplay || maxSalaryDisplay;
        const isSameValue =
          minSalaryParted && maxSalaryParted
            ? JSON.stringify(minSalaryParted) === JSON.stringify(maxSalaryParted)
            : false;

        return (
          <p key={`${employmentTypeName}_${salaryTypeName}`}>
            {employmentTypeName} / {salaryTypeName}
            {hasSalary && (
              <>
                {minSalaryDisplay}
                {!isSameValue && " 〜 "}
                {!isSameValue && maxSalaryDisplay}
              </>
            )}
            {!hasSalary && (minPrice || maxPrice) && (
              <>
                <span className={styles.salaryText}>{minPrice}</span>
                {minUnit}
                {minPrice !== maxPrice && (
                  <>
                    {" 〜 "}
                    <span className={styles.salaryText}>{maxPrice}</span>
                    {maxUnit}
                  </>
                )}
              </>
            )}
            {isEllipsisDisplay && <>…</>}
          </p>
        );
      },
    )}
  </div>
);
